import { useFormContext } from 'react-hook-form';
import type { SelectChangeEvent } from '@mui/material';
import SelectBase from '../../../../../console/workflows/primeX-underwriter/components/footer/SelectBase';
import { withFormController } from '../../../../hocs/forms';
import TextFieldBase from '../../../../inputs/text-fields/base/TextFieldBase';
import { useTableState } from '../../providers/TableStateProvider';

type InputProps = {
  name: string;
};

export const TableFilterInputFactory = (props: InputProps) => {
  return <TextField name={props.name} />;
};

const TextField = withFormController(TextFieldBase);

export const ColumnSelect = (props: InputProps) => {
  const tableState = useTableState();
  const formCtx = useFormContext();

  const _options = Object.values(tableState.columnFilters).map((col) => ({
    label: col.text,
    value: col.key,
    meta: col,
  }));

  const handleChange = (e: SelectChangeEvent<any>) => {
    const meta = _options.find((opt) => opt.value === e.target.value)?.meta;
    formCtx.setValue(props.name, {
      value: e.target.value,
      meta,
    });
  };

  return (
    <SelectBase name={props.name} options={_options} onChange={handleChange} />
  );
};

export const FilterSelect = (props: InputProps) => {
  const formCtx = useFormContext();
  const idx = props.name.split('.')[1];

  const columnSelectType = formCtx.watch(`filters.${idx}.columnName`)?.meta
    ?.type;

  const options =
    FILTER_SELECT_OPTIONS_MAPPINGS[
      columnSelectType as keyof typeof FILTER_SELECT_OPTIONS_MAPPINGS
    ] ?? [];

  return <SelectFieldInput name={props.name} options={options} />;
};

const SelectFieldInput = withFormController(SelectBase);

const FILTER_SELECT_OPTIONS_MAPPINGS = {
  string: [
    { label: 'equals', value: 'eq' },
    { label: 'does not equal', value: 'ne' },
  ],
  boolean: [{ label: 'is', value: 'bo' }],
};
